/**
 * Stripe Configuration
 * Centralized Stripe keys and configuration
 */

// Determine if we're in production based on hostname or environment variable
const isProduction = () => {
  // Check if explicitly set to use live mode via env variable
  if (import.meta.env.VITE_STRIPE_LIVE_MODE === 'true') {
    return true;
  }
  
  // Check if we're on a production domain
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    return hostname !== 'localhost' && 
           !hostname.startsWith('127.') && 
           !hostname.startsWith('192.') &&
           !hostname.includes('local');
  }
  
  return false;
};

// Keys configuration
const TEST_KEYS = {
  PUBLISHABLE_KEY: 'pk_test_51Rm18bPQ9AdW7pP6F0k8AGqhTw9StOO16bH72tbuu1Bg8ln53XkvEURoWag0CLUAEitEf99dSi97ceHaEPS7Y3io00GWjxv6jE',
  // Test Price IDs
  STANDARD_PRICE_ID: 'price_1S0SCKPQ9AdW7pP6uv3kPc8x',
  PREMIUM_PRICE_ID: 'price_1S0SFhPQ9AdW7pP6wgkKpqtF',
};

const LIVE_KEYS = {
  PUBLISHABLE_KEY: 'pk_live_51Rm18TAmTJIc4vVRe4IKfmk8nQA7LRLw3j2adQiCmBPw0RSkPcERwD6BlBG2cBB6CiGt9uFKvUFpAB70ruGYAUoQ00vKFm0uEo',
  // Live price IDs from Stripe Dashboard
  STANDARD_PRICE_ID: 'price_1S0q4oAmTJIc4vVR7awaNbTw', // CampusConnect Standard Plan (prod_SwjXQtn5dMU23D)
  PREMIUM_PRICE_ID: 'price_1S0q4kAmTJIc4vVRP4eFa15L',  // CampusConnect Premium Plan (prod_SwjXcPX9Chf6Pk)
};

export const STRIPE_CONFIG = {
  // Dynamically select keys based on environment
  PUBLISHABLE_KEY: isProduction() ? LIVE_KEYS.PUBLISHABLE_KEY : TEST_KEYS.PUBLISHABLE_KEY,
  
  // Price IDs - automatically switch between test and live based on environment
  STANDARD_PRICE_ID: isProduction() ? LIVE_KEYS.STANDARD_PRICE_ID : TEST_KEYS.STANDARD_PRICE_ID,
  PREMIUM_PRICE_ID: isProduction() ? LIVE_KEYS.PREMIUM_PRICE_ID : TEST_KEYS.PREMIUM_PRICE_ID,
  
  // Add-on Price IDs (keep test for now)
  PARENT_COMMUNICATION_PRICE_ID: 'price_1QRkdLPQ9AdW7pP6oMArBdDg',
  DOCUSIGN_PRICE_ID: 'price_1QRkdMPQ9AdW7pP6pNBsCeEh',
  VIDEO_CONFERENCING_PRICE_ID: 'price_1QRkdNPQ9AdW7pP6qOCtDfFi',
};

export const getStripePublishableKey = (): string => {
  const key = STRIPE_CONFIG.PUBLISHABLE_KEY;
  
  // Log warning in console if using live keys
  if (key.startsWith('pk_live_')) {
    console.warn('⚠️ STRIPE LIVE MODE ACTIVE - Real charges will occur!');
  } else {
    console.log('✅ Stripe Test Mode - No real charges will occur');
  }
  
  return key;
};

export const isTestMode = (): boolean => {
  return STRIPE_CONFIG.PUBLISHABLE_KEY.startsWith('pk_test_');
};

export default STRIPE_CONFIG;